// src/components/navigation/UserAvatar.tsx

import React from "react";

interface UserAvatarProps {
  avatar: string | null;
  initials: string;
  displayName: string;
  size?: "sm" | "md" | "lg";
}

const SIZE_CLASSES = {
  sm: "h-8 w-8 text-xs",
  md: "h-9 w-9 text-xs",
  lg: "h-20 w-20 text-lg",
};

export const UserAvatar: React.FC<UserAvatarProps> = ({
  avatar,
  initials,
  displayName,
  size = "md",
}) => {
  const [imageFailed, setImageFailed] = React.useState(false);

  React.useEffect(() => {
    setImageFailed(false);
  }, [avatar]);

  const showImage = Boolean(avatar) && !imageFailed;

  return (
    <div
      className={`
        flex shrink-0 items-center justify-center
        overflow-hidden rounded-full
        border border-[#D7ECE8]
        bg-[#E0F7F4]
        ${SIZE_CLASSES[size]}
      `}
    >
      {showImage ? (
        <img
          src={avatar ?? ""}
          alt={`${displayName} profile`}
          className="h-full w-full object-cover"
          loading="lazy"
          onError={() => setImageFailed(true)}
        />
      ) : (
        <span className="font-semibold text-[#117E78]">
          {initials}
        </span>
      )}
    </div>
  );
};

export default UserAvatar;